'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ids = require('@brandwatch/axiom-automation-testing/ids');

var _ids2 = _interopRequireDefault(_ids);

var _Dropdown = require('../Dropdown/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _DropdownContent = require('../Dropdown/DropdownContent');

var _DropdownContent2 = _interopRequireDefault(_DropdownContent);

var _DropdownContext = require('../Dropdown/DropdownContext');

var _DropdownContext2 = _interopRequireDefault(_DropdownContext);

var _DropdownSource = require('../Dropdown/DropdownSource');

var _DropdownSource2 = _interopRequireDefault(_DropdownSource);

var _DropdownTarget = require('../Dropdown/DropdownTarget');

var _DropdownTarget2 = _interopRequireDefault(_DropdownTarget);

var _Grid = require('../Grid/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _GridCell = require('../Grid/GridCell');

var _GridCell2 = _interopRequireDefault(_GridCell);

var _ColorPickerOption = require('./ColorPickerOption');

var _ColorPickerOption2 = _interopRequireDefault(_ColorPickerOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorPicker = function (_Component) {
  _inherits(ColorPicker, _Component);

  function ColorPicker() {
    _classCallCheck(this, ColorPicker);

    return _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).apply(this, arguments));
  }

  _createClass(ColorPicker, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabledOptions = _props.disabledOptions,
          onOpen = _props.onOpen,
          onSelectColor = _props.onSelectColor,
          options = _props.options,
          selected = _props.selected,
          width = _props.width,
          size = _props.size,
          rest = _objectWithoutProperties(_props, ['disabledOptions', 'onOpen', 'onSelectColor', 'options', 'selected', 'width', 'size']);

      return _react2.default.createElement(
        _Dropdown2.default,
        _extends({ position: 'bottom' }, rest, { showArrow: true }),
        _react2.default.createElement(
          _DropdownTarget2.default,
          null,
          _react2.default.createElement(_ColorPickerOption2.default, {
            color: selected,
            'data-ax-at': _ids2.default.ColorPicker.dropdown,
            onClick: onOpen,
            size: size })
        ),
        _react2.default.createElement(
          _DropdownSource2.default,
          null,
          _react2.default.createElement(
            _DropdownContext2.default,
            { width: width },
            _react2.default.createElement(
              _DropdownContent2.default,
              null,
              _react2.default.createElement(
                _Grid2.default,
                {
                  gutters: 'small',
                  horizontalAlign: 'middle',
                  responsive: false },
                options.map(function (color) {
                  var isColorDisabled = disabledOptions.indexOf(color) !== -1;
                  return _react2.default.createElement(
                    _GridCell2.default,
                    { key: color, shrink: true },
                    _react2.default.createElement(_ColorPickerOption2.default, {
                      color: color,
                      'data-ax-at': _ids2.default.ColorPicker.option,
                      disabled: isColorDisabled,
                      onClick: function onClick() {
                        return isColorDisabled || onSelectColor(color);
                      } })
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);

  return ColorPicker;
}(_react.Component);

ColorPicker.propTypes = {
  /** Colors that should be disabled from selection */
  disabledOptions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['forbidden-planet', 'tiny-clanger', 'critical-mass', 'fantastic-voyage', 'paradise-lost', 'serene-sea', 'event-horizon', 'electric-dreams', 'outer-limits', 'giant-leap', 'moon-lagoon', 'space-invader', 'extraterrestrial', 'terra-form', 'primeval-soup', 'future-shock', 'sun-maker', 'new-horizon', 'blast-off', 'crash-course', 'solar-rust', 'ground-control', 'space-oddity', 'rocky-planet', 'deep-thought', 'luna-dust'])),
  /** Callback for when the color picker has been opened */
  onOpen: _propTypes2.default.func,
  /** Callback for when a color has been selected, provided with the selected color */
  onSelectColor: _propTypes2.default.func.isRequired,
  /** Colors that should be visible for selection */
  options: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['forbidden-planet', 'tiny-clanger', 'critical-mass', 'fantastic-voyage', 'paradise-lost', 'serene-sea', 'event-horizon', 'electric-dreams', 'outer-limits', 'giant-leap', 'moon-lagoon', 'space-invader', 'extraterrestrial', 'terra-form', 'primeval-soup', 'future-shock', 'sun-maker', 'new-horizon', 'blast-off', 'crash-course', 'solar-rust', 'ground-control', 'space-oddity', 'rocky-planet', 'deep-thought', 'luna-dust'])),
  /** Color that should appear as selected */
  selected: _propTypes2.default.oneOf(['forbidden-planet', 'tiny-clanger', 'critical-mass', 'fantastic-voyage', 'paradise-lost', 'serene-sea', 'event-horizon', 'electric-dreams', 'outer-limits', 'giant-leap', 'moon-lagoon', 'space-invader', 'extraterrestrial', 'terra-form', 'primeval-soup', 'future-shock', 'sun-maker', 'new-horizon', 'blast-off', 'crash-course', 'solar-rust', 'ground-control', 'space-oddity', 'rocky-planet', 'deep-thought', 'luna-dust']),
  /** Diameter of the color picker button */
  size: _propTypes2.default.string,
  /** Width of the color selection container */
  width: _propTypes2.default.string
};
ColorPicker.defaultProps = {
  disabledOptions: [],
  options: ['tiny-clanger', 'critical-mass', 'paradise-lost', 'serene-sea', 'giant-leap', 'moon-lagoon', 'terra-form', 'primeval-soup', 'new-horizon', 'blast-off', 'ground-control', 'luna-dust'],
  width: '9rem'
};
exports.default = ColorPicker;